/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Illegal_Chars_LabelInputs */

const en_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detect Illegal Chararacters (608)`)
};

const fr_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détecter les caractères illégaux (608)`)
};

const de_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illegale Zeichen erkennen (608)`)
};

const it_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rileva caratteri illegali (608)`)
};

const ru_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выявление недопустимых символов (608)`)
};

const es_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar personajes ilegales (608)`)
};

const zh_cn2_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测非法字符 (608)`)
};

const ja_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正な文字を検出する (608)`)
};

const hi_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवैध वर्णों का पता लगाना (608)`)
};

const pt_pt2_edit_event_group_illegal_chars_label = /** @type {(inputs: Edit_Event_Group_Illegal_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar caracteres ilegais (608)`)
};

/**
* | output |
* | --- |
* | "Detect Illegal Chararacters (608)" |
*
* @param {Edit_Event_Group_Illegal_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_illegal_chars_label = /** @type {((inputs?: Edit_Event_Group_Illegal_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Illegal_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_illegal_chars_label(inputs)
	if (locale === "de") return de_edit_event_group_illegal_chars_label(inputs)
	if (locale === "it") return it_edit_event_group_illegal_chars_label(inputs)
	if (locale === "ru") return ru_edit_event_group_illegal_chars_label(inputs)
	if (locale === "es") return es_edit_event_group_illegal_chars_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_illegal_chars_label(inputs)
	if (locale === "ja") return ja_edit_event_group_illegal_chars_label(inputs)
	if (locale === "hi") return hi_edit_event_group_illegal_chars_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_illegal_chars_label(inputs)
	return en_edit_event_group_illegal_chars_label(inputs)
});